/**
 * @module services/appointment-modal
 * @description Reglas del modal de turno (`components/appointment/
 *              ModalAppointment.vue`) extraídas para poder testearlas sin
 *              montar el SFC (vue-jest no compila su template).
 */

/** @description Mensaje cuando no hay paciente elegido. */
export const PATIENT_REQUIRED_MESSAGE = "El campo Paciente es obligatorio";

/** @description Mensaje cuando el alta rápida está abierta sin guardar. */
export const UNSAVED_NEW_PATIENT_MESSAGE =
  "Guardá el paciente nuevo con «Crear y seleccionar» antes de agendar.";

/**
 * @description Motivo por el que "Agendar" no debe avanzar por el paciente,
 *              o null si se puede agendar.
 * @param {Object} state
 * @param {boolean} state.isPatient - Portal paciente (el paciente es el user)
 * @param {string|null} state.patientId - Paciente elegido para el turno
 * @param {boolean} state.creatingPatient - Form de alta rápida abierto
 * @returns {string|null}
 */
export function getPatientBlockReason({
  isPatient,
  patientId,
  creatingPatient,
}) {
  if (isPatient) return null;
  // UC-REG-270: con el alta rápida abierta el validador "Paciente" del
  // modal no está montado; sin este corte el API respondía 400 y el modal
  // se cerraba perdiendo lo tipeado.
  if (creatingPatient) return UNSAVED_NEW_PATIENT_MESSAGE;
  if (!patientId) return PATIENT_REQUIRED_MESSAGE;
  return null;
}
